<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fm_head" id="_idParaDest-1"><a id="_idTextAnchor000"></a><a href="#/text/9780062914811_Contents#r_idParaDest-1"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Dedication</span></a></h2>
<p class="ded_txt1"><i>For Rowen, whose alchemy set everything in motion</i></p>
<p class="ded_txt"><i>and whose magic continues to delight us.</i></p>
<p class="ded_txt01"><i>And for all women who recognize themselves in these pages.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062914811_Dedication.vue?579b4c8e